import type { HTMLAttributes, ReactNode } from 'react';
import styled from '@emotion/styled';
import { uiTheme as t } from './theme';

export interface FieldErrorProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

const Root = styled.div({
  fontFamily: t.font,
  fontSize: '0.8125rem',
  lineHeight: 1.4,
  color: t.color.danger,
  marginTop: '0.25rem',
});

/**
 * Mensaje de error bajo un control.
 *
 * Mantiene un solo estilo para todos los formularios de `Components/ui`.
 */
const FieldError = ({ children, ...props }: FieldErrorProps) => <Root {...props}>{children}</Root>;

export default FieldError;
